<nav class="subnav">
  <ul class="nav">
    <li class="nav-item">
      <a class="nav-link active" [routerLink]="['/settings']">Zur Konfiguration</a>
    </li>
  </ul>
</nav>

<main>
  <h2>PHM PPS  <cds-icon shape="two-way-arrows"></cds-icon>  Konfiguration  <cds-icon shape="two-way-arrows"></cds-icon>  Zahlungs- und Lieferbedingungen</h2>

  <div class="clr-row" >
    <div class="clr-col-6">
      <div class="card">
        <div class="card-header">
          Zahlungsbedingungen
        </div>
        <div class="card-block">
          <div class="card-text">

            <form clrForm
                  [formGroup]="conditionsPaymentForm">

              <clr-datagrid *ngIf="editPayment < 2" [clrDgLoading]="loading" id="paymentDataGrid">
                <clr-dg-column [clrDgField]="'name'" [clrDgSortOrder]="descSort">Bezeichnung</clr-dg-column>
                <clr-dg-column>Beschreibung</clr-dg-column>
                <clr-dg-column [clrDgField]="'payment_term'" style="text-align:right">Zahlungsziel</clr-dg-column>
                <clr-dg-column [clrDgField]="'discount'" style="text-align:right">Skonto (%)</clr-dg-column>
                <clr-dg-column *ngIf="editPayment === 1">Aktion</clr-dg-column>
                <clr-dg-placeholder>
                  <div class="datagrid-placeholder">
                    <!-- Info-Icon nur wenn verfügbar, sonst nur Text -->
                    <cds-icon shape="info-circle" aria-hidden="true" style="margin-right:8px"></cds-icon>
                    <span>Keine Zahlungsbedingungen gefunden</span>
                  </div>
                </clr-dg-placeholder>

                <clr-dg-row *clrDgItems="let payment_condition of payment_conditions; index as i;">
                  <clr-dg-cell>{{ payment_condition.name }}</clr-dg-cell>
                  <clr-dg-cell>{{ payment_condition.text }}</clr-dg-cell>
                  <clr-dg-cell style="text-align:right">{{ payment_condition.payment_term }}</clr-dg-cell>
                  <clr-dg-cell style="text-align:right">{{ payment_condition.discount }}</clr-dg-cell>
                  <clr-dg-cell *ngIf="editPayment === 1" class="btn-group btn-primary btn-icon">

                    <button *ngIf="!updatingPayment" class="btn btn-sm" (click)="updatePaymentMode(i, payment_condition.cond_id)" aria-label="Zahlungsbedingung bearbeiten" title="Ändern">
                      <cds-icon shape="pencil" aria-hidden="true"></cds-icon>
                      <span class="clr-icon-title">Ändern</span>
                    </button>
                    <button class="btn btn-warning btn-sm" (click)="deletePayment(payment_condition.cond_id, payment_condition.name)" aria-label="Zahlungsbedingung löschen" title="Löschen">
                      <cds-icon shape="times" aria-hidden="true"></cds-icon>
                      <span class="clr-icon-title">Löschen</span>
                    </button>

                  </clr-dg-cell>
                </clr-dg-row>

                <clr-dg-row *ngIf="(editPayment === 1) && !updatingPayment">
                  <clr-dg-cell><input type="text" formControlName="name" placeholder="Bezeichnung" class="clr-input" required></clr-dg-cell>
                  <clr-dg-cell><input type="text" formControlName="text" placeholder="Beschreibung" class="clr-input"></clr-dg-cell>
                  <clr-dg-cell style="text-align:right"><input type="number" formControlName="payment_term" placeholder="Zahlungsziel" class="clr-input" aria-label="Zahlungsziel"></clr-dg-cell>
                  <clr-dg-cell style="text-align:right"><input type="number" formControlName="discount" placeholder="Skonto (%)" class="clr-input" aria-label="Skonto in Prozent"></clr-dg-cell>
                  <clr-dg-cell class="btn-group btn-primary btn-icon">

                    <button class="btn btn-sm" (click)="addPayment()" [disabled]="conditionsPaymentForm.invalid" aria-label="Zahlungsbedingung speichern" title="Speichern">
                      <cds-icon shape="floppy" aria-hidden="true"></cds-icon>
                      <span class="clr-icon-title">Speichern</span>
                    </button>

                  </clr-dg-cell>
                </clr-dg-row>

                <clr-dg-footer>
                  <clr-dg-pagination #pagination [clrDgPageSize]="50">
                    <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Zahlungsbedingungen pro Seite</clr-dg-page-size>
                    {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
                    von {{payment_conditions.length}} Zahlungsbedingung(en)
                  </clr-dg-pagination>
                </clr-dg-footer>
              </clr-datagrid>

              <app-edit-condition *ngIf="editPayment === 2" [editCondition]="editPaymentNumber" [editType]="editPaymentType" (updatedCondition)="onUpdatePayment($event)"></app-edit-condition>

              <br />
              <a *ngIf="editPayment === 1" class="btn btn-primary btn-sm" (click)="editPayment = 0; updatingPayment = false; updatePaymentIndex = 999">Bearbeitung beenden</a>
              <a *ngIf="editPayment === 0" class="btn btn-primary btn-sm" (click)="editPayment = 1">Zahlungsbedingungen bearbeiten</a>

            </form>

          </div>
        </div>
      </div>
    </div>

    <div class="clr-col-6">
      <div class="card">
        <div class="card-header">
          Lieferbedingungen
        </div>
        <div class="card-block">
          <div class="card-text">

            <form clrForm
                  [formGroup]="conditionsDeliveryForm">

              <clr-datagrid *ngIf="editDelivery < 2" [clrDgLoading]="loading" id="deliveryDataGrid">
                <clr-dg-column [clrDgField]="'name'" [clrDgSortOrder]="descSort">Bezeichnung</clr-dg-column>
                <clr-dg-column>Beschreibung</clr-dg-column>
                <clr-dg-column>Abweichende Lieferadresse</clr-dg-column>
                <clr-dg-column *ngIf="editDelivery === 1">Aktion</clr-dg-column>
                <clr-dg-placeholder>
                  <div class="datagrid-placeholder">
                    <cds-icon shape="info-circle" aria-hidden="true" style="margin-right:8px"></cds-icon>
                    <span>Keine Lieferbedingungen gefunden</span>
                  </div>
                </clr-dg-placeholder>

                <clr-dg-row *clrDgItems="let delivery_condition of delivery_conditions; index as i;">
                  <clr-dg-cell>{{ delivery_condition.name }}</clr-dg-cell>
                  <clr-dg-cell>{{ delivery_condition.text }}</clr-dg-cell>
                  <clr-dg-cell><cds-icon *ngIf="delivery_condition.option" shape="check-circle" size="md" solid="true"></cds-icon></clr-dg-cell>
                  <clr-dg-cell *ngIf="editDelivery === 1" class="btn-group btn-primary btn-icon">

                    <button *ngIf="!updatingDelivery" class="btn btn-sm" (click)="updateDeliveryMode(i, delivery_condition.cond_id)" aria-label="Lieferbedingung bearbeiten" title="Ändern">
                      <cds-icon shape="pencil" aria-hidden="true"></cds-icon>
                      <span class="clr-icon-title">Ändern</span>
                    </button>
                    <button class="btn btn-warning btn-sm" (click)="deleteDelivery(delivery_condition.cond_id, delivery_condition.name)" aria-label="Lieferbedingung löschen" title="Löschen">
                      <cds-icon shape="times" aria-hidden="true"></cds-icon>
                      <span class="clr-icon-title">Löschen</span>
                    </button>

                  </clr-dg-cell>
                </clr-dg-row>

                <clr-dg-row *ngIf="(editDelivery === 1) && !updatingDelivery">
                  <clr-dg-cell><input type="text" formControlName="name" placeholder="Bezeichnung" class="clr-input" required></clr-dg-cell>
                  <clr-dg-cell><input type="text" formControlName="text" placeholder="Beschreibung" class="clr-input"></clr-dg-cell>
                  <clr-dg-cell><input type="checkbox" formControlName="option" class="clr-checkbox"></clr-dg-cell>
                  <clr-dg-cell class="btn-group btn-primary btn-icon">

                    <button class="btn btn-sm" (click)="addDelivery()" [disabled]="conditionsDeliveryForm.invalid" aria-label="Lieferbedingung speichern" title="Speichern">
                      <cds-icon shape="floppy" aria-hidden="true"></cds-icon>
                      <span class="clr-icon-title">Speichern</span>
                    </button>

                  </clr-dg-cell>
                </clr-dg-row>

                <clr-dg-footer>
                  <clr-dg-pagination #pagination [clrDgPageSize]="50">
                    <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Lieferbedingungen pro Seite</clr-dg-page-size>
                    {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
                    von {{delivery_conditions.length}} Lieferbedingung(en)
                  </clr-dg-pagination>
                </clr-dg-footer>
              </clr-datagrid>

              <app-edit-condition *ngIf="editDelivery === 2" [editCondition]="editDeliveryNumber" [editType]="editDeliveryType" (updatedCondition)="onUpdateDelivery($event)"></app-edit-condition>

              <br />
              <a *ngIf="editDelivery === 1" class="btn btn-primary btn-sm" (click)="editDelivery = 0; updatingDelivery = false; updateDeliveryIndex = 999">Bearbeitung beenden</a>
              <a *ngIf="editDelivery === 0" class="btn btn-primary btn-sm" (click)="editDelivery = 1">Lieferbedingungen bearbeiten</a>

            </form>

          </div>
        </div>
      </div>
    </div>
  </div>
</main>
